<!-- 星星区域 -->
<template>
  <div class="star-region-com">
    <img
      v-for="item in startDate"
      :key="item.id"
      :class="{
        start: true,
        'big-start': item.big,
      }"
      :src="imgUrlMap.start1"
      :style="item.style"
      alt=""
    />
  </div>
</template>
<script setup>

import { reactive, ref, computed, onBeforeMount, onMounted, defineProps, defineExpose, defineEmits, nextTick } from 'vue'
import { Toast } from 'vant';
import anime from 'animejs/lib/anime.es.js';

const props = defineProps({
  // 封面图片地址
  imgUrlMap: {
    type: Object,
    default: () => { }
  },
})
const emit = defineEmits([]);

const startDate = ref([])

onMounted(() => {
});

// 星星数据数初始化
const initStartDate = (count = 20) => {
  console.log('星星数据数初始化', count);

  let arr = []
  for (let i = 0; i < count; i++) {
    arr.push({
      id: i,
      style: `top: ${getRandomNumber()}%;left: ${getRandomNumber()}%;`,
      big: getOneTenthProbability()
    })
  }
  startDate.value = arr
  nextTick(() => {
    startAnimation()
  })
}
// 星星闪烁动画
const startAnimation = () => {
  anime({
    targets: '.star-region-com .start',
    // opacity: [0.3, 1, 0.1],
    // scale: [0.3, 1, 0.3],
    keyframes: [
      { opacity: 1, scale: 0.3, },
      { opacity: 0.5, scale: 0.6, },
      { opacity: 1, scale: 1, },

    ],
    // flipInX
    // keyframes: [
    //   { translateX: 1, translateY: 0, translateZ: 0, rotate: 90, perspective: 400, },
    //   { translateX: 1, translateY: 0, translateZ: 0, rotate: -20, perspective: 400, },
    //   { translateX: 1, translateY: 0, translateZ: 0, rotate: 10, perspective: 400, },
    //   { translateX: 1, translateY: 0, translateZ: 0, rotate: -5, perspective: 400, },
    //   { perspective: 400, },

    // ],
    // flash
    // keyframes: [
    //   { opacity: 1, },
    //   { opacity: 0.5, },
    // ],

    direction: 'alternate',
    loop: true,
    easing: 'easeInOutSine',
    duration: () => Math.random() * 500 + 300, // 随机持续时间 300-800ms
    delay: () => Math.random() * 1000, // 随机延迟 0-1000ms
  })
}
// 星星消失
const startDisappear = () => {
  anime.remove('.start-box .start'); // 移除所有星星元素的动画
  anime({
    targets: '.star-region-com .start',
    opacity: 0,
    easing: 'easeInOutSine',
    duration: () => Math.random() * 500 + 300, // 随机持续时间 300-800ms
    delay: () => Math.random() * 1000, // 随机延迟 0-1000ms
    complete: () => {
      startDate.value = 0
    }
  })
}

const getRandomNumber = () => {
  return Math.floor(Math.random() * 90) + 1
}
// 设置10分之一的概率
const getOneTenthProbability = () => {
  const randomNum = Math.floor(Math.random() * 10) + 1;
  return randomNum === 1; // 当随机数为1时返回true，即10%的概率
}

defineExpose({
  initStartDate,
  startAnimation,
  startDisappear,
})

</script>
<style  lang="less" scoped>
.star-region-com {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  // top: 200px;
  // left: 5%;
  // z-index: 3;
  position: relative;
  .start {
    position: absolute;
    width: 30px;
  }
  .big-start {
    width: 47px;
  }
}
</style>
